import Auth from '@/helpers/authorizations'
import Management from '@/layouts/Management'

export default {
  path: '/nvr_channels',
  component: Management,
  redirect: '/nvr_channels/list',
  children: [
    // 列表页
    {
      path: 'list',
      component: () => import('@/views/nvr_channels/List'),
      meta: {
        auth: Auth.listNvrChannels
      },
      redirect: 'list/all',
      children: [
        {
          path: 'all',
          component: () => import('@/views/nvr_channels/ListTable'),
          meta: {
            auth: Auth.listNvrChannels,
            tabName: 'all'
          }
        }
      ]
    },
    // 详情
    {
      path: ':id',
      component: () => import('@/views/nvr_channels/DetailLayout'),
      meta: {
        auth: Auth.showNvrChannel
      },
      children: [
        // 基本信息
        {
          path: 'detail',
          component: () => import('@/views/nvr_channels/details/Detail'),
          meta: {
            tabName: 'detail', // 标签页的标签名，用于确认活动的标签页
            auth: Auth.showNvrChannel
          }
        },
        {
          path: 'play',
          component: () => import('@/views/nvr_channels/details/Play'),
          meta: {
            tabName: 'play', // 标签页的标签名，用于确认活动的标签页
            auth: Auth.showNvrChannel
          }
        },
        {
          path: 'third_party_service_traces',
          component: () => import('@/views/nvr_channels/details/ThirdPartyServiceTraces'),
          meta: {
            tabName: 'third_party_service_traces', // 标签页的标签名，用于确认活动的标签页
            auth: Auth.listThirdPartyServiceTraces
          }
        }
      ]
    }
  ]
}
